import { MultiSelect } from "../../../../shared/components/select/MultiSelect";
import { useEffect, useRef, useState } from "react";
import RangeDatePicker from "../../../../shared/components/datepicker/RangeDatePicker";
import {
  BackpackIcon,
  BarChartIcon,
  GlobeIcon,
  MixerHorizontalIcon,
  PersonIcon,
} from "@radix-ui/react-icons";
import ActionsPerformanceFilterPanel from "./ActionsPerformanceFilterPanel";

const ActionsPerformanceFilters = ({
  selectables,
  defaultDateValue,
  onDateChangeValue,
  onStrategyChangeValue,
  onChannelChangeValue,
  onPlatformChangeValue,
  onClientChangeValue,
  onCampaignChangeValue,
  onMarketChangeValue,
  onCategoryChangeValue,
  onProductChangeValue,
}) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const clientsRef = useRef();

  const [campaigns, setCampaigns] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  const onClientChangeValueHandler = (client) => {
    if (client.length > 0) {
      updateDependantStates(setCampaigns, client, (value) => value.campaigns);
      updateDependantStates(setMarkets, client, (value) => value.markets);
      updateDependantStates(setCategories, client, (value) => value.categories);
      updateDependantStates(setProducts, client, (value) => value.products);
      setIsDisabled(false);
    } else {
      setCampaigns([]);
      setMarkets([]);
      setCategories([]);
      setProducts([]);
      setIsDisabled(true);
    }
    onClientChangeValue(client);
  };

  const updateDependantStates = (setStateFunction, clients, mapFunction) => {
    setStateFunction(
      clientsRef.current
        .filter((value) => clients.includes(value.client.value))
        .map(mapFunction)
        .flat(),
    );
  };

  useEffect(() => {
    clientsRef.current = selectables?.clients;
  }, [selectables]);

  return (
    <div className="flex flex-col gap-y-4 py-4 px-8 justify-center">
      <ActionsPerformanceFilterPanel
        title="Filtros"
        icon={<MixerHorizontalIcon />}
      >
        <RangeDatePicker
          className="mb-2"
          onValueChange={onDateChangeValue}
          defaultValue={defaultDateValue}
        />
      </ActionsPerformanceFilterPanel>
      <ActionsPerformanceFilterPanel title="Clientes" icon={<PersonIcon />}>
        <MultiSelect
          placeholder="Elegir clientes"
          options={selectables?.clients.map((client) => client.client)}
          onValueChange={onClientChangeValueHandler}
        />
      </ActionsPerformanceFilterPanel>
      <ActionsPerformanceFilterPanel title="Trading" icon={<BarChartIcon />}>
        <MultiSelect
          placeholder={
            isDisabled
              ? "Elija cliente para activar campañas"
              : "Elegir campañas"
          }
          options={campaigns}
          onValueChange={onCampaignChangeValue}
          isDisabled={isDisabled}
        />
        <MultiSelect
          placeholder="Elegir plataformas"
          options={selectables?.platforms}
          onValueChange={onPlatformChangeValue}
        />
        <MultiSelect
          placeholder="Elegir canales"
          options={selectables?.channels}
          onValueChange={onChannelChangeValue}
        />
        <MultiSelect
          placeholder="Elegir estrategias"
          options={selectables?.strategies}
          onValueChange={onStrategyChangeValue}
        />
      </ActionsPerformanceFilterPanel>
      <ActionsPerformanceFilterPanel title="Productos" icon={<BackpackIcon />}>
        <MultiSelect
          placeholder={
            isDisabled
              ? "Elija cliente para activar categorías"
              : "Elegir categorías"
          }
          options={categories}
          onValueChange={onCategoryChangeValue}
          isDisabled={isDisabled}
        />
        <MultiSelect
          placeholder={
            isDisabled
              ? "Elija cliente para activar productos"
              : "Elegir productos"
          }
          options={products}
          onValueChange={onProductChangeValue}
          isDisabled={isDisabled}
        />
      </ActionsPerformanceFilterPanel>
      <ActionsPerformanceFilterPanel title="Mercados" icon={<GlobeIcon />}>
        <MultiSelect
          placeholder={
            isDisabled
              ? "Elija cliente para activar mercados"
              : "Elegir mercados"
          }
          options={markets}
          onValueChange={onMarketChangeValue}
          isDisabled={isDisabled}
        />
      </ActionsPerformanceFilterPanel>
    </div>
  );
};

export default ActionsPerformanceFilters;
